import React from "react";
import '../style/Policy.css';
import { t } from "i18next";

const Policy = () => (
    <main className="about_content">
        <div className="content">
            <h1 className="m_0">{t('privacy_policy')}</h1>
        </div>
        <div className="content">
            <section className="policy-section">
                <h2>{t('privacy_policy1')}</h2>
                <ul>
                    <li><strong>{t('privacy_policy2')}</strong> – {t('privacy_policy3')}</li>
                    <li><strong>{t('privacy_policy4')}</strong> – {t('privacy_policy5')} <a href="https://agroland.kz">agroland.kz</a>.</li>
                    <li><strong>{t('privacy_policy6')}</strong> – {t('privacy_policy7')}</li>
                </ul>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy8')}</h2>
                <p>{t('privacy_policy9')}</p>
                <p>{t('privacy_policy10')}</p>
                <p>{t('privacy_policy11')}</p>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy12')}</h2>
                <ul>
                    <li><strong>{t('privacy_policy13')}</strong>: {t('privacy_policy14')}</li>
                    <li><strong>{t('privacy_policy15')}</strong>: {t('privacy_policy16')}</li>
                    <li><strong>{t('privacy_policy17')}</strong>: {t('privacy_policy18')}</li>
                    <li><strong>{t('privacy_policy19')}</strong>: {t('privacy_policy20')}</li>
                </ul>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy21')}</h2>
                <p>{t('privacy_policy22')}</p>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy23')}</h2>
                <p>{t('privacy_policy24')}</p>
                <p>{t('privacy_policy25')}</p>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy26')}</h2>
                <p>{t('privacy_policy27')}</p>
                <p>{t('privacy_policy28')}</p>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy29')}</h2>
                <ul>
                    <li>{t('privacy_policy30')}</li>
                    <li>{t('privacy_policy31')}</li>
                    <li>{t('privacy_policy32')}</li>
                </ul>
                <p>{t('privacy_policy33')}</p>
            </section>

            <section className="policy-section">
                <h2>{t('privacy_policy34')}</h2>
                <p>{t('privacy_policy35')}</p>
                <p>{t('privacy_policy36')}</p>
            </section>
        </div>
    </main>
);

export default Policy;